import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import SC from "./style";
import { makeStyles } from "@mui/styles";
import theme from "theme";

export default function BasicSelect(props) {
  const {
    value = "",
    onChange = () => {},
    options = [],
    label = "",
    sx,
  } = props;

  const useStyles = makeStyles(() => ({
    customScrollbar: {
      "&::-webkit-scrollbar": {
        width: 5,
      },
      "&::-webkit-scrollbar-track": {
        background: `${theme.colors.bordertask}`,
      },
      "&::-webkit-scrollbar-thumb": {
        background: `${theme.colors.themeColor}`,
        borderRadius: 10,
      },
    },
  }));

  const classes = useStyles();

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 200,
        overflowY: "scroll",
      },
      classes: {
        root: classes.customScrollbar,
      },
    },
  };

  return (
    <>
      {SC.GlobalStyles}
      <FormControl fullWidth size="small">
        <InputLabel id="demo-simple-select-label" style={{ fontSize: "14px" }}>
          {label || ""}
        </InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value || ""}
          label={label}
          onChange={onChange}
          sx={{ ...SC.selectBox, ...sx }}
          MenuProps={MenuProps}
        >
          {options.map((item) => {
            return (
              <MenuItem key={item.value} sx={sx} value={item.value}>
                {item.label || ""}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </>
  );
}
